import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';
import { brokerRecommendation, brokers } from '@/mocks/brokers';

export default function BrokerTeaser() {
  const teaser = brokerRecommendation.homeTeaser;

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <ScrollReveal>
          <div className="rounded-xl border border-background-200 bg-background-100/60 p-5 md:p-7">
            <div className="flex flex-col gap-7 lg:flex-row lg:items-center lg:justify-between lg:gap-10">
              <div className="max-w-xl">
                <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-600">
                  <span className="h-px w-6 bg-accent-500" />
                  {teaser.eyebrow}
                </span>
                <h2 className="mt-3 font-heading text-xl font-semibold leading-snug text-foreground-950 md:text-2xl">
                  {teaser.title}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{teaser.desc}</p>

                <p className="mt-5 text-[11px] font-medium uppercase tracking-[0.14em] text-foreground-400">
                  {teaser.benefitsTitle}
                </p>
                <ul className="mt-2.5 flex flex-col gap-2.5">
                  {teaser.benefits.map((benefit) => (
                    <li key={benefit.title} className="flex items-start gap-3">
                      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                        <i className={`${benefit.icon} text-sm`} />
                      </span>
                      <div className="min-w-0">
                        <p className="text-sm font-medium leading-snug text-foreground-900">{benefit.title}</p>
                        <p className="mt-0.5 text-[12px] leading-relaxed text-foreground-600">{benefit.desc}</p>
                      </div>
                    </li>
                  ))}
                </ul>

                <Link
                  to={teaser.path}
                  className="mt-5 inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:border-primary-400 hover:bg-primary-50"
                >
                  {teaser.cta}
                  <i className="ri-arrow-right-line text-base" />
                </Link>
              </div>

              <div className="w-full lg:w-[380px] lg:shrink-0">
                <p className="mb-2.5 text-[11px] font-medium uppercase tracking-[0.14em] text-foreground-400">
                  เทียบไว้ {brokers.length} แห่ง
                </p>
                <div className="flex flex-col gap-2">
                  {brokers.map((broker) => (
                    <div
                      key={broker.id}
                      className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 px-3 py-3 transition-colors hover:border-primary-200 hover:bg-primary-50/40"
                    >
                      <img
                        src={broker.logo}
                        alt={`${broker.name} logo`}
                        title={broker.name}
                        className="h-9 w-9 shrink-0 rounded-md bg-background-100 object-contain"
                      />
                      <div className="min-w-0 flex-1">
                        <p className="truncate font-heading text-sm font-semibold text-foreground-900">
                          {broker.name}
                        </p>
                        <p className="mt-0.5 line-clamp-2 text-[11px] leading-relaxed text-foreground-600">
                          {broker.tagline}
                        </p>
                        <span className="mt-1.5 inline-flex max-w-full items-center rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] leading-tight text-secondary-900">
                          <span className="min-w-0 truncate">{broker.card.platforms}</span>
                        </span>
                      </div>
                      <i className="ri-arrow-right-s-line mt-1 shrink-0 text-base text-foreground-400" />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <p className="mt-5 border-t border-background-200 pt-3.5 text-[11px] leading-relaxed text-foreground-500">
              {teaser.note}
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}